/**
 * _chat_tabs.js — pure rules for which Chip widget tab shows on load.
 *
 * Used by chat_tabs_controller.js; no DOM access so tests/js/chat_tabs.test.mjs
 * can exercise it directly. The leading underscore keeps esm/index.js from
 * registering it as a controller.
 */

export const TABS = ['chip', 'support'];

/** The ?support=open deep link that push notifications and emails use. */
export function opensSupport(urlParams) {
    return urlParams.get('support') === 'open';
}

/**
 * The tab to show first: Support when Chip AI is unavailable or the deep link
 * asks for it, else the tab remembered on this device, else Chip AI.
 */
export function initialTab(storedTab, chipAvailable, urlParams) {
    if (!chipAvailable || opensSupport(urlParams)) return 'support';
    return TABS.includes(storedTab) ? storedTab : 'chip';
}

/**
 * The thread a staff deep link names (?support=open&conversation=<id>, from a
 * support push to staff), or null.
 */
export function supportConversation(urlParams) {
    if (!opensSupport(urlParams)) return null;
    const id = Number(urlParams.get('conversation'));
    return Number.isInteger(id) && id > 0 ? id : null;
}

/** The same URL with the support deep-link params removed, for history.replaceState. */
export function urlWithoutSupportParam(href) {
    const url = new URL(href);
    url.searchParams.delete('support');
    url.searchParams.delete('conversation');
    return url.toString();
}
